import ModalForm from '../../../shared/components/modal-form';

export default class MentorshipRequest extends ModalForm {
  constructor() {
    super(...arguments);

    this.$messageBodyInput = this.$element.find(
      '.mentorshipRequest-messageBody'
    );
    this.$conversationButtonElement = this.$element.find(
      '.mentorshipRequest-confirmation-conversationButton'
    );
    this.$confirmationElement = this.$element.find(
      '.mentorshipRequest-confirmation'
    );

    this.bindEvents();
  }

  handleModalHide() {
    if (this.formWasSuccessful) {
      window.Turbolinks.reload();
    }

    super.handleModalHide();
  }

  handleFormSuccess(_, data) {
    const conversationPath = data.conversation_path;
    this.$conversationButtonElement.attr('href', conversationPath);
    this.$confirmationElement.show();

    super.handleFormSuccess(...arguments);
  }
}
